var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      on: {
        click: function(event) {
          if (!_vm.disabled) {
            _vm.$emit("click", event)
          }
        }
      }
    },
    [
      _c(
        "el-form",
        {
          staticStyle: { display: "inline-block" },
          attrs: { disabled: _vm.disabled }
        },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }